import React from 'react';
import { Box, Typography } from '@mui/material';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'default';
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open, title, message,
  confirmLabel = 'Confirm', cancelLabel = 'Cancel',
  variant = 'default',
  onConfirm, onCancel,
}) => {
  if (!open) return null;
  return (
    <Box sx={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,.5)', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }} onClick={onCancel}>
      <Box sx={{
        background: 'var(--glass-bg)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
        border: '1px solid var(--glass-border)', borderRadius: '18px',
        p: '24px 28px', minWidth: 320, maxWidth: 440,
        boxShadow: '0 24px 64px rgba(0,0,0,.45)',
        display: 'flex', flexDirection: 'column', gap: '14px',
      }} onClick={e => e.stopPropagation()}>
        <Typography sx={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)', lineHeight: 1.3 }}>
          {title}
        </Typography>
        {message && (
          <Typography sx={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.55 }}>
            {message}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', mt: '6px' }}>
          <Box component="button" onClick={onCancel}
            sx={{
              px: '18px', py: '8px', borderRadius: '9px', fontSize: 12, fontWeight: 600,
              fontFamily: 'inherit', cursor: 'pointer',
              background: 'var(--glass-bg)', border: '1px solid var(--glass-border)',
              color: 'var(--text-secondary)', transition: 'all .15s',
              '&:hover': { background: 'var(--glass-hover)', color: 'var(--text-primary)' },
            }}>
            {cancelLabel}
          </Box>
          <Box component="button" onClick={onConfirm}
            sx={{
              px: '18px', py: '8px', borderRadius: '9px', fontSize: 12, fontWeight: 600,
              fontFamily: 'inherit', cursor: 'pointer', transition: 'all .15s',
              ...(variant === 'danger'
                ? {
                    background: 'rgba(248,113,113,.15)', border: '1px solid rgba(248,113,113,.35)',
                    color: '#f87171',
                    '&:hover': { background: 'rgba(248,113,113,.26)', borderColor: 'rgba(248,113,113,.55)' },
                  }
                : {
                    background: 'var(--accent)', border: 'none', color: '#fff',
                    '&:hover': { opacity: .85 },
                  }),
            }}>
            {confirmLabel}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ConfirmModal;
